import { createAction, props } from '@ngrx/store';
import { ResponseIsCTSEmployee } from '../../shared/interfaces';
import { IsCTSEmployeeTypes } from '../../shared/enums';

export const getIsCTSEmployee = createAction(
    IsCTSEmployeeTypes.IS_CTS_EMPLOYEE
);

export const getIsCTSEmployeeSucess = createAction(
    IsCTSEmployeeTypes.IS_CTS_EMPLOYEE_SUCCESS,
    props<{ response: ResponseIsCTSEmployee }>()
);

export const getIsCTSEmployeeError = createAction(
    IsCTSEmployeeTypes.IS_CTS_EMPLOYEE_ERROR,
    props<{ payload: any }>()
);

export const cleanState = createAction(
    IsCTSEmployeeTypes.CLEAN_STATE
);

